import { AlertBannerType } from './types';

export const variant: Record<AlertBannerType, string> = {
  tooltip: 'bg-blue-300 text-white',
  error: 'bg-danger-400 text-white',
  warning: 'bg-warning-50 border border-warning-500 text-warning-700',
};
